
export const menuData = {
  pizza: {
    categories: [
      {
        name: {
          fr: "Nos Pizzas",
          en: "Our Pizzas",
          it: "Le Nostre Pizze",
          ar: "البيتزا"
        },
        items: [
          {
            name: {
              fr: "Margherita",
              en: "Margherita",
              it: "Margherita",
              ar: "مارغريتا"
            },
            description: {
              fr: "Sauce tomate, basilic frais, mozzarella covelli, parmigiano",
              en: "Tomato sauce, fresh basil, covelli mozzarella, parmesan",
              it: "Salsa di pomodoro, basilico fresco, mozzarella covelli, parmigiano",
              ar: "صلصة طماطم، ريحان طازج، موتزاريلا كوفيلي، بارميزان"
            },
            price: "24.00"
          },
          {
            name: {
              fr: "Tuna",
              en: "Tuna",
              it: "Tonno",
              ar: "تونة"
            },
            description: {
              fr: "Sauce tomate, basilic frais, mozzarella covelli, thon épicé, olives noires",
              en: "Tomato sauce, fresh basil, covelli mozzarella, spicy tuna, black olives",
              it: "Salsa di pomodoro, basilico fresco, mozzarella covelli, tonno piccante, olive nere",
              ar: "صلصة طماطم، ريحان طازج، موتزاريلا كوفيلي، تونة حارة، زيتون أسود"
            },
            price: "30.00"
          },
          {
            name: {
              fr: "Siciliano",
              en: "Siciliano",
              it: "Siciliana",
              ar: "صقلية"
            },
            description: {
              fr: "Sauce tomate, basilic frais, mozzarella covelli, anchois, olives, câpres",
              en: "Tomato sauce, fresh basil, covelli mozzarella, anchovies, olives, capers",
              it: "Salsa di pomodoro, basilico fresco, mozzarella covelli, acciughe, olive, capperi",
              ar: "صلصة طماطم، ريحان طازج، موتزاريلا كوفيلي، أنشوجة، زيتون، قبار"
            },
            price:  "28.00"
          },
          {
            name: {
              fr: "Funghi",
              en: "Funghi",
              it: "Funghi",
              ar: "فطر"
            },
            description: {
              fr: "Crème, basilic frais, mozzarella, champignons, sauce truffe, covelli, roquette, parmigiano",
              en: "Cream, fresh basil, mozzarella, mushrooms, truffle sauce, covelli, arugula, parmesan",
              it: "Panna, basilico fresco, mozzarella, funghi, salsa al tartufo, covelli, rucola, parmigiano",
              ar: "كريمة، ريحان طازج، موتزاريلا، فطر، صلصة الكمأة، كوفيلي، جرجير، بارميزان"
            },
            price: "36.00"
          },
          {
            name: {
              fr: "Marinara",
              en: "Marinara",
              it: "Marinara",
              ar: "مارينارا"
            },
            description: {
              fr: "Sauce tomate, basilic frais, tomate cerise, parmigiano, ail",
              en: "Tomato sauce, fresh basil, cherry tomatoes, parmesan, garlic",
              it: "Salsa di pomodoro, basilico fresco, pomodorini, parmigiano, aglio",
              ar: "صلصة طماطم، ريحان طازج، طماطم كرزية، بارميزان، ثوم"
            },
            price: "20.00"
          },
          {
            name: {
              fr: "Latina",
              en: "Latina",
              it: "Latina",
              ar: "لاتينا"
            },
            description: {
              fr: "Sauce tomate, basilic frais, mozzarella covelli, bresaola, tomates séchées, roquette, parmigiano",
              en: "Tomato sauce, fresh basil, covelli mozzarella, bresaola, sun-dried tomatoes, arugula, parmesan",
              it: "Salsa di pomodoro, basilico fresco, mozzarella covelli, bresaola, pomodori secchi, rucola, parmigiano",
              ar: "صلصة طماطم، ريحان طازج، موتزاريلا كوفيلي، بريزاولا، طماطم مجففة، جرجير، بارميزان"
            },
            price: "38.00"
          },
          {
            name: {
              fr: "Pepperoni",
              en: "Pepperoni",
              it: "Pepperoni",
              ar: "بيبروني"
            },
            description: {
              fr: "Sauce tomate, basilic frais, mozzarella covelli, chorizo, parmigiano, olives, huile piquante",
              en: "Tomato sauce, fresh basil, covelli mozzarella, chorizo, parmesan, olives, spicy oil",
              it: "Salsa di pomodoro, basilico fresco, mozzarella covelli, chorizo, parmigiano, olive, olio piccante",
              ar: "صلصة طماطم، ريحان طازج، موتزاريلا كوفيلي، تشوريزو، بارميزان، زيتون، زيت حار"
            },
            price: "32.00"
          },
          {
            name: {
              fr: "Chèvre & Miel",
              en: "Goat Cheese & Honey",
              it: "Capra e Miele",
              ar: "جبن الماعز والعسل"
            },
            description: {
              fr: "Crème, basilic frais, mozzarella covelli, fromage de chèvre, ricotta, noix, miel, roquette, parmigiano",
              en: "Cream, fresh basil, covelli mozzarella, goat cheese, ricotta, walnuts, honey, arugula, parmesan",
              it: "Panna, basilico fresco, mozzarella covelli, formaggio di capra, ricotta, noci, miele, rucola, parmigiano",
              ar: "كريمة، ريحان طازج، موتزاريلا كوفيلي، جبن الماعز، ريكوتا، جوز، عسل، جرجير، بارميزان"
            },
            price: "38.00"
          },
          {
            name: {
              fr: "Frutti di Mare",
              en: "Seafood",
              it: "Frutti di Mare",
              ar: "غلال البحر"
            },
            description: {
              fr: "Sauce tomate, basilic frais, mozzarella covelli, cocktail de fruits de mer",
              en: "Tomato sauce, fresh basil, covelli mozzarella, mixed seafood",
              it: "Salsa di pomodoro, basilico fresco, mozzarella covelli, cocktail di frutti di mare",
              ar: "صلصة طماطم، ريحان طازج، موتزاريلا كوفيلي، تشكيلة غلال البحر"
            },
            price:  "42.00"
          },
          {
            name: {
              fr: "Salmone",
              en: "Salmon",
              it: "Salmone",
              ar: "سلمون"
            },
            description: {
              fr: "Crème, mozzarella covelli, basilic frais, saumon fumé, zeste de citron, parmigiano",
              en: "Cream, covelli mozzarella, fresh basil, smoked salmon, lemon zest, parmesan",
              it: "Panna, mozzarella covelli, basilico fresco, salmone affumicato, scorza di limone, parmigiano",
              ar: "كريمة، موتزاريلا كوفيلي، ريحان طازج، سلمون مدخن، قشر الليمون، بارميزان"
            },
            price: "38.00"
          },
          {
            name: {
              fr: "Capricciosa",
              en: "Capricciosa",
              it: "Capricciosa",
              ar: "كابريتشوزا"
            },
            description: {
              fr: "Sauce tomate, mozzarella, basilic frais, jambon fumé, champignons frais, artichaut",
              en: "Tomato sauce, mozzarella, fresh basil, smoked ham, fresh mushrooms, artichoke",
              it: "Salsa di pomodoro, mozzarella, basilico fresco, prosciutto affumicato, funghi freschi, carciofi",
              ar: "صلصة طماطم، موتزاريلا، ريحان طازج، لحم مدخن، فطر طازج، خرشوف"
            },
            price: "36.00"
          },
          {
            name: {
              fr: "Pesto Gamberi",
              en: "Pesto Prawns",
              it: "Pesto Gamberi",
              ar: "بيستو بالجمبري"
            },
            description: {
              fr: "Crème, basilic frais, sauce pesto, mozzarella covelli, crevettes, tomates séchées, parmigiano",
              en: "Cream, fresh basil, pesto sauce, covelli mozzarella, prawns, sun-dried tomatoes, parmesan",
              it: "Panna, basilico fresco, salsa al pesto, mozzarella covelli, gamberi, pomodori secchi, parmigiano",
              ar: "كريمة، ريحان طازج، صلصة البيستو، موتزاريلا كوفيلي، جمبري، طماطم مجففة، بارميزان"
            },
            price: "42.00"
          },
          {
            name: {
              fr: "Burrata",
              en: "Burrata",
              it: "Burrata",
              ar: "بوراتا"
            },
            description: {
              fr: "Sauce tomate, basilic frais, mozzarella covelli, burrata, tomate cerise, pistache concassée, roquette",
              en: "Tomato sauce, fresh basil, covelli mozzarella, burrata, cherry tomatoes, crushed pistachios, arugula",
              it: "Salsa di pomodoro, basilico fresco, mozzarella covelli, burrata, pomodorini, granella di pistacchio, rucola",
              ar: "صلصة طماطم، ريحان طازج، موتزاريلا كوفيلي، بوراتا، طماطم كرزية، فستق مطحون، جرجير"
            },
            price: "38.00"
          },
          {
            name: {
              fr: "Cinque Formaggi",
              en: "Five Cheeses",
              it: "Cinque Formaggi",
              ar: "خمسة أجبان"
            },
            description: {
              fr: "Sauce au choix, basilic frais, mozzarella covelli, gorgonzola, scamorza fumé, ricotta, parmigiano",
              en: "Sauce of choice, fresh basil, covelli mozzarella, gorgonzola, smoked scamorza, ricotta, parmesan",
              it: "Salsa a scelta, basilico fresco, mozzarella covelli, gorgonzola, scamorza affumicata, ricotta, parmigiano",
              ar: "صلصة حسب الاختيار، ريحان طازج، موتزاريلا كوفيلي، جورجونزولا، سكامورزا مدخنة، ريكوتا، بارميزان"
            },
            price: "35.00"
          },
          {
            name: {
              fr: "Vegetariano",
              en: "Vegetarian",
              it: "Vegetariana",
              ar: "نباتية"
            },
            description: {
              fr: "Sauce tomate, basilic frais, mozzarella covelli, aubergine, courgette, olives, oignon, champignon, poivron, tomate séchée, roquette",
              en: "Tomato sauce, fresh basil, covelli mozzarella, eggplant, zucchini, olives, onion, mushroom, pepper, sun-dried tomato, arugula",
              it: "Salsa di pomodoro, basilico fresco, mozzarella covelli, melanzane, zucchine, olive, cipolla, funghi, peperoni, pomodori secchi, rucola",
              ar: "صلصة طماطم، ريحان طازج، موتزاريلا كوفيلي، باذنجان، كوسة، زيتون، بصل، فطر، فلفل، طماطم مجففة، جرجير"
            },
            price: "28.00"
          },
          {
            name: {
              fr: "Milano",
              en: "Milano",
              it: "Milano",
              ar: "ميلانو"
            },
            description: {
              fr: "Mozzarella covelli, huile d'olive, basilic frais, jambon fumé, stracciatella, sauce pesto, pistache concassée",
              en: "Covelli mozzarella, olive oil, fresh basil, smoked ham, stracciatella, pesto sauce, crushed pistachios",
              it: "Mozzarella covelli, olio d'oliva, basilico fresco, prosciutto affumicato, stracciatella, salsa al pesto, granella di pistacchio",
              ar: "موتزاريلا كوفيلي، زيت زيتون، ريحان طازج، لحم مدخن، ستراتشياتيلا، صلصة بيستو، فستق مطحون"
            },
            price: "40.00"
          },
          {
            name: {
              fr: "Pollo",
              en: "Chicken",
              it: "Pollo",
              ar: "دجاج"
            },
            description: {
              fr: "Sauce rose, basilic frais, mozzarella, poulet fumé, tomate cerise, ricotta, parmigiano",
              en: "Pink sauce, fresh basil, mozzarella, smoked chicken, cherry tomatoes, ricotta, parmesan",
              it: "Salsa rosa, basilico fresco, mozzarella, pollo affumicato, pomodorini, ricotta, parmigiano",
              ar: "صلصة وردية، ريحان طازج، موتزاريلا، دجاج مدخن، طماطم كرزية، ريكوتا، بارميزان"
            },
            price: "34.00"
          }
        ]
      }
    ]
  },
  "main": {
    "categories": [
      {
        "name": {
          "fr": "Antipasti",
          "en": "Starters",
          "it": "Antipasti",
          "ar": "المقبلات"
        },
        "items": [
          {
            "name": {
              "fr": "Focaccia",
              "en": "Focaccia",
              "it": "Focaccia",
              "ar": "فوكاتشيا"
            },
            "description": {
              "fr": "Parmesan, tomate cerise, noix, roquette",
              "en": "Parmesan, cherry tomato, walnuts, arugula",
              "it": "Parmigiano, pomodorini, noci, rucola",
              "ar": "بارميزان، طماطم كرزية، جوز، جرجير"
            },
            "price": "15.00"
          },
          {
            "name": {
              "fr": "Burrata all'italiana",
              "en": "Italian Burrata",
              "it": "Burrata all'italiana",
              "ar": "بوراتا إيطالية"
            },
            "description": {
              "fr": "Salade de tomate à la burrata, basilic et huile d'olive",
              "en": "Tomato salad with burrata, basil and olive oil",
              "it": "Insalata di pomodoro alla burrata, basilico e olio d'oliva",
              "ar": "سلطة طماطم مع بوراتا، ريحان وزيت زيتون"
            },
            "price": "38.00"
          },
          {
            "name": {
              "fr": "Caprese con avocado",
              "en": "Caprese with Avocado",
              "it": "Caprese con avocado",
              "ar": "كابريزي مع الأفوكادو"
            },
            "description": {
              "fr": "Tomate, mozzarella, avocat",
              "en": "Tomato, mozzarella, avocado",
              "it": "Pomodoro, mozzarella, avocado",
              "ar": "طماطم، موتزاريلا، أفوكادو"
            },
            "price": "38.00"
          },
          {
            "name": {
              "fr": "Salmone gravlax",
              "en": "Salmon Gravlax",
              "it": "Salmone gravlax",
              "ar": "سلمون جرافلاكس"
            },
            "description": {
              "fr": "Saumon mariné et légumes",
              "en": "Marinated salmon and vegetables",
              "it": "Salmone marinato e verdure",
              "ar": "سلمون متبل وخضروات"
            },
            "price": "38.00"
          },
          {
            "name": {
              "fr": "Parmigiana di melanzane",
              "en": "Eggplant Parmigiana",
              "it": "Parmigiana di melanzane",
              "ar": "باذنجان بارميجيانا"
            },
            "description": {
              "fr": "Lasagne d'aubergine, parmesan & mozzarella gratinés au four",
              "en": "Eggplant lasagna, parmesan & mozzarella gratinated in the oven",
              "it": "Lasagne di melanzane, parmigiano e mozzarella gratinati al forno",
              "ar": "لازانيا الباذنجان، بارميزان وموتزاريلا محمصة في الفرن"
            },
            "price": "38.00"
          },
          {
            "name": {
              "fr": "Insalata di frutti di mare",
              "en": "Seafood Salad",
              "it": "Insalata di frutti di mare",
              "ar": "سلطة فواكه البحر"
            },
            "description": {
              "fr": "Salade de fruits de mer",
              "en": "Mixed seafood salad",
              "it": "Insalata di mare",
              "ar": "سلطة فواكه البحر المشكلة"
            },
            "price": "38.00"
          },
          {
            "name": {
              "fr": "Insalata aqua farina",
              "en": "Aqua Farina Salad",
              "it": "Insalata aqua farina",
              "ar": "سلطة أكوا فارينا"
            },
            "description": {
              "fr": "Signature de la maison",
              "en": "House signature salad",
              "it": "Firma della casa",
              "ar": "سلطة التوقيع الخاصة بالمطعم"
            },
            "price": "38.00"
          },
          {
            "name": {
              "fr": "Carpaccio di manzo",
              "en": "Beef Carpaccio",
              "it": "Carpaccio di manzo",
              "ar": "كارباتشيو لحم البقر"
            },
            "description": {
              "fr": "Carpaccio de bœuf",
              "en": "Beef carpaccio",
              "it": "Carpaccio di manzo",
              "ar": "شرائح لحم البقر الرقيقة"
            },
            "price": "44.00"
          },
          {
            "name": {
              "fr": "Cocktail di gamberi",
              "en": "Shrimp Cocktail",
              "it": "Cocktail di gamberi",
              "ar": "كوكتيل الجمبري"
            },
            "description": {
              "fr": "Cocktail de crevettes",
              "en": "Shrimp cocktail",
              "it": "Cocktail di gamberi",
              "ar": "كوكتيل الروبيان"
            },
            "price": "40.00"
          }
        ]
      },
      {
        "name": {
          "fr": "Primi",
          "en": "First Courses (Pasta)",
          "it": "Primi",
          "ar": "الأطباق الأولى"
        },
        "items": [
          {
            "name": {
              "fr": "Ravioli di ricotta e spinaci",
              "en": "Ricotta and Spinach Ravioli",
              "it": "Ravioli di ricotta e spinaci",
              "ar": "رافيولي الريكوتا والسبانخ"
            },
            "description": {
              "fr": "Ravioles à la ricotta et aux épinards",
              "en": "Ravioli with ricotta and spinach",
              "it": "Ravioli alla ricotta e spinaci",
              "ar": "رافيولي محشو بالريكوتا والسبانخ"
            },
            "price": "38.00"
          },
          {
            "name": {
              "fr": "Penne al pesto e pollo grigliato",
              "en": "Penne Pesto and Grilled Chicken",
              "it": "Penne al pesto e pollo grigliato",
              "ar": "بيني بالبيستو والدجاج المشوي"
            },
            "description": {
              "fr": "Penne au pesto de basilic frais et émincé de poulet grillé",
              "en": "Penne with fresh basil pesto and sliced grilled chicken",
              "it": "Penne al pesto di basilico fresco e straccetti di pollo grigliato",
              "ar": "بيني مع بيستو الريحان الطازج وشرائح الدجاج المشوي"
            },
            "price": "38.00"
          },
          {
            "name": {
              "fr": "Spaghetti bolognese",
              "en": "Spaghetti Bolognese",
              "it": "Spaghetti bolognese",
              "ar": "سباغيتي بولونيز"
            },
            "description": {
              "fr": "Spaghetti à la sauce bolognaise",
              "en": "Spaghetti with bolognese sauce",
              "it": "Spaghetti alla bolognese",
              "ar": "سباغيتي بصلصة البولونيز"
            },
            "price": "38.00"
          },
          {
            "name": {
              "fr": "Ravioli al salmone",
              "en": "Salmon Ravioli",
              "it": "Ravioli al salmone",
              "ar": "رافيولي السلمون"
            },
            "description": {
              "fr": "Ravioles au saumon",
              "en": "Salmon ravioli",
              "it": "Ravioli al salmone",
              "ar": "رافيولي محشو بالسلمون"
            },
            "price": "40.00"
          },
          {
            "name": {
              "fr": "Penne ai cinque formaggi",
              "en": "Five Cheese Penne",
              "it": "Penne ai cinque formaggi",
              "ar": "بيني بخمسة أجبان"
            },
            "description": {
              "fr": "Penne cinq fromages",
              "en": "Five cheese penne",
              "it": "Penne ai cinque formaggi",
              "ar": "بيني مع خمسة أنواع من الجبن"
            },
            "price": "42.00"
          },
          {
            "name": {
              "fr": "Lasagne tradizionale all'italiana",
              "en": "Traditional Italian Lasagna",
              "it": "Lasagne tradizionale all'italiana",
              "ar": "لازانيا إيطالية تقليدية"
            },
            "description": {
              "fr": "Lasagne traditionnelle",
              "en": "Traditional lasagna",
              "it": "Lasagna tradizionale",
              "ar": "لازانيا تقليدية"
            },
            "price": "42.00"
          },
          {
            "name": {
              "fr": "Spaghetti ai gamberi",
              "en": "Prawn Spaghetti",
              "it": "Spaghetti ai gamberi",
              "ar": "سباغيتي بالجمبري"
            },
            "description": {
              "fr": "Spaghetti aux crevettes",
              "en": "Spaghetti with prawns",
              "it": "Spaghetti ai gamberi",
              "ar": "سباغيتي مع الجمبري"
            },
            "price": "44.00"
          },
          {
            "name": {
              "fr": "Risotto pollo e funghi e tartufo",
              "en": "Chicken, Mushroom and Truffle Risotto",
              "it": "Risotto pollo e funghi e tartufo",
              "ar": "ريزوتو الدجاج والفطر والكمأة"
            },
            "description": {
              "fr": "Risotto ou pate au poulet, champignons et truffe",
              "en": "Risotto or pasta with chicken, mushrooms and truffle",
              "it": "Risotto o pasta al pollo, funghi e tartufo",
              "ar": "ريزوتو أو مكرونة مع الدجاج، الفطر والكمأة"
            },
            "price": "44.00"
          },
          {
            "name": {
              "fr": "Spaghetti tartufo e manzo",
              "en": "Truffle and Beef Spaghetti",
              "it": "Spaghetti tartufo e manzo",
              "ar": "سباغيتي الكمأة ولحم البقر"
            },
            "description": {
              "fr": "Spaghetti à la crème de truffe noire et fines lamelles de bœuf",
              "en": "Spaghetti with black truffle cream and thin beef strips",
              "it": "Spaghetti alla crema di tartufo nero e fettine di manzo",
              "ar": "سباغيتي بكريمة الكمأة السوداء وشرائح رقيقة من لحم البقر"
            },
            "price": "52.00"
          },
          {
            "name": {
              "fr": "Linguine calamari e bottarga",
              "en": "Squid and Bottarga Linguine",
              "it": "Linguine calamari e bottarga",
              "ar": "لينغويني مع الحبار والبوتارغا"
            },
            "description": {
              "fr": "Linguine aux calamars et à la boutargue",
              "en": "Linguine with squid and bottarga",
              "it": "Linguine ai calamari e bottarga",
              "ar": "لينغويني مع الحبار والبوتارغا"
            },
            "price": "52.00"
          },
          {
            "name": {
              "fr": "Risotto ai frutti di mare",
              "en": "Seafood Risotto",
              "it": "Risotto ai frutti di mare",
              "ar": "ريزوتو فواكه البحر"
            },
            "description": {
              "fr": "Risotto aux fruits de mer",
              "en": "Seafood risotto",
              "it": "Risotto ai frutti di mare",
              "ar": "ريزوتو مع فواكه البحر"
            },
            "price": "52.00"
          },
          {
            "name": {
              "fr": "Spaghetti ai frutti di mare",
              "en": "Seafood Spaghetti",
              "it": "Spaghetti ai frutti di mare",
              "ar": "سباغيتي فواكه البحر"
            },
            "description": {
              "fr": "Spaghetti aux fruits de mer",
              "en": "Seafood spaghetti",
              "it": "Spaghetti ai frutti di mare",
              "ar": "سباغيتي مع فواكه البحر"
            },
            "price": "52.00"
          }
        ]
      },
      {
        "name": {
          "fr": "Secondi",
          "en": "Main Courses",
          "it": "Secondi",
          "ar": "الأطباق الرئيسية"
        },
        "items": [
          {
            "name": {
              "fr": "Filetto di manzo con salsa chimichurri",
              "en": "Beef Fillet with Chimichurri Sauce",
              "it": "Filetto di manzo con salsa chimichurri",
              "ar": "فيليه لحم بقر بصلصة تشيميتشوري"
            },
            "description": {
              "fr": "Filet de bœuf, sauce chimichurri (tomate, basilic, persil, ail, origan, huile, vinaigre)",
              "en": "Beef fillet, chimichurri sauce (tomato, basil, parsley, garlic, oregano, oil, vinegar)",
              "it": "Filetto di manzo, salsa chimichurri (pomodoro, basilico, prezzemolo, aglio, origano, olio, aceto)",
              "ar": "فيليه لحم بقر، صلصة تشيميتشوري (طماطم، ريحان، بقدونس، ثوم، زعتر، زيت، خل)"
            },
            "price": "62.00"
          },
          {
            "name": {
              "fr": "Salmone grigliato con verdure",
              "en": "Grilled Salmon with Vegetables",
              "it": "Salmone grigliato con verdure",
              "ar": "سلمون مشوي مع خضار"
            },
            "description": {
              "fr": "Saumon grillé et légumes",
              "en": "Grilled salmon and vegetables",
              "it": "Salmone grigliato e verdure",
              "ar": "سلمون مشوي وخضروات"
            },
            "price": "54.00"
          },
          {
            "name": {
              "fr": "Filetto di branzino in crosta",
              "en": "Crusted Sea Bass Fillet",
              "it": "Filetto di branzino in crosta",
              "ar": "فيليه القاروص في قشرة"
            },
            "description": {
              "fr": "Filet de poisson en croute de pommes de terre",
              "en": "Fish fillet in potato crust",
              "it": "Filetto di pesce in crosta di patate",
              "ar": "فيليه سمك في قشرة من البطاطس"
            },
            "price": "42.00"
          },
          {
            "name": {
              "fr": "Polpo grigliato con pureé e verdure",
              "en": "Grilled Octopus with Puree and Vegetables",
              "it": "Polpo grigliato con pureé e verdure",
              "ar": "أخطبوط مشوي مع بيوريه وخضروات"
            },
            "description": {
              "fr": "Poulpe grillé avec purée de pommes de terre et légumes",
              "en": "Grilled octopus with mashed potatoes and vegetables",
              "it": "Polpo grigliato con purea di patate e verdure",
              "ar": "أخطبوط مشوي مع هريس البطاطس وخضروات"
            },
            "price": "58.00"
          },
          {
            "name": {
              "fr": "Misto di mare alla griglia",
              "en": "Mixed Grilled Seafood",
              "it": "Misto di mare alla griglia",
              "ar": "مشويات بحرية مشكلة"
            },
            "description": {
              "fr": "Grillade mixte de fruits de la mer",
              "en": "Mixed grilled seafood",
              "it": "Grigliata mista di mare",
              "ar": "تشكيلة مشويات من فواكه البحر"
            },
            "price": "64.00"
          },
          {
            "name": {
              "fr": "Scaloppina di pollo ai funghi e tartufo",
              "en": "Chicken Escalope with Mushroom and Truffle",
              "it": "Scaloppina di pollo ai funghi e tartufo",
              "ar": "اسكالوب الدجاج بالفطر والكمأة"
            },
            "description": {
              "fr": "Escalope de poulet aux champignons",
              "en": "Chicken escalope with mushrooms",
              "it": "Scaloppina di pollo ai funghi",
              "ar": "اسكالوب دجاج مع الفطر"
            },
            "price": "42.00"
          },
          {
            "name": {
              "fr": "Tagliata di manzo con rucola pomodorini e grana",
              "en": "Beef Tagliata with Arugula, Cherry Tomatoes and Grana",
              "it": "Tagliata di manzo con rucola pomodorini e grana",
              "ar": "تاغليتا لحم البقر مع الجرجير والطماطم الكرزية وجبن جرانا"
            },
            "description": {
              "fr": "Entrecôte de boeuf avec roquette, tomates cerises et parmesan",
              "en": "Beef entrecôte with arugula, cherry tomatoes and parmesan",
              "it": "Entrecote di manzo con rucola, pomodorini e parmigiano",
              "ar": "شريحة لحم بقر مع الجرجير والطماطم الكرزية والبارميزان"
            },
            "price": "55.00"
          }
        ]
      },
      {
        "name": {
          "fr": "Dolce",
          "en": "Desserts",
          "it": "Dolce",
          "ar": "الحلويات"
        },
        "items": [
          {
            "name": {
              "fr": "Tiramisu traditionnel",
              "en": "Traditional Tiramisu",
              "it": "Tiramisù tradizionale",
              "ar": "تيراميسو تقليدي"
            },
            "description": {
              "fr": "Tiramisu traditionnel",
              "en": "Traditional tiramisu",
              "it": "Tiramisù tradizionale",
              "ar": "تيراميسو تقليدي"
            },
            "price": "18.00"
          },
          {
            "name": {
              "fr": "Cannoli sicilien",
              "en": "Sicilian Cannoli",
              "it": "Cannoli siciliani",
              "ar": "كانولي صقلي"
            },
            "description": {
              "fr": "Cannoli sicilien",
              "en": "Sicilian cannoli",
              "it": "Cannoli siciliani",
              "ar": "كانولي صقلي"
            },
            "price": "16.00"
          },
          {
            "name": {
              "fr": "Panna cotta",
              "en": "Panna Cotta",
              "it": "Panna Cotta",
              "ar": "بانا كوتا"
            },
            "description": {
              "fr": "Panna cotta",
              "en": "Panna cotta",
              "it": "Panna cotta",
              "ar": "بانا كوتا"
            },
            "price": "15.00"
          }
        ]
      },
      {
        "name": {
          "fr": "Bevande",
          "en": "Drinks",
          "it": "Bevande",
          "ar": "المشروبات"
        },
        "items": [
          {
            "name": {
              "fr": "Eau plate 1L",
              "en": "Still Water 1L",
              "it": "Acqua Naturale 1L",
              "ar": "ماء معدني 1 لتر"
            },
            "description": {
              "fr": "Eau plate 1L",
              "en": "Still water 1L",
              "it": "Acqua naturale 1L",
              "ar": "ماء معدني 1 لتر"
            },
            "price": "6.00"
          },
          {
            "name": {
              "fr": "San Pellegrino",
              "en": "San Pellegrino",
              "it": "San Pellegrino",
              "ar": "سان بيليغرينو"
            },
            "description": {
              "fr": "Eau pétillante",
              "en": "Sparkling water",
              "it": "Acqua frizzante",
              "ar": "مياه غازية"
            },
            "price": "10.00"
          },
          {
            "name": {
              "fr": "Acqua Panna",
              "en": "Acqua Panna",
              "it": "Acqua Panna",
              "ar": "أكوا بانا"
            },
            "description": {
              "fr": "Eau minérale",
              "en": "Mineral water",
              "it": "Acqua minerale",
              "ar": "مياه معدنية"
            },
            "price": "10.00"
          },
          {
            "name": {
              "fr": "Soda",
              "en": "Soda",
              "it": "Soda",
              "ar": "مشروبات غازية"
            },
            "description": {
              "fr": "Soda",
              "en": "Soda",
              "it": "Bibita",
              "ar": "مشروب غازي"
            },
            "price": "6.00"
          },
          {
            "name": {
              "fr": "Nespresso",
              "en": "Nespresso",
              "it": "Caffè Nespresso",
              "ar": "نسبريسو"
            },
            "description": {
              "fr": "Nespresso",
              "en": "Nespresso coffee",
              "it": "Caffè Nespresso",
              "ar": "قهوة نسبريسو"
            },
            "price": "7.00"
          },
          {
            "name": {
              "fr": "Jus frais",
              "en": "Fresh Juice",
              "it": "Spremuta fresca",
              "ar": "عصير طازج"
            },
            "description": {
              "fr": "Jus frais",
              "en": "Fresh juice",
              "it": "Succo fresco",
              "ar": "عصير فواكه طازج"
            },
            "price": "12.00"
          },
          {
            "name": {
              "fr": "Cocktails",
              "en": "Cocktails",
              "it": "Cocktail",
              "ar": "كوكتيلات"
            },
            "description": {
              "fr": "Cocktails",
              "en": "Cocktails",
              "it": "Cocktail",
              "ar": "كوكتيلات"
            },
            "price": "15.00"
          },
          {
            "name": {
              "fr": "Virgin Mojito",
              "en": "Virgin Mojito",
              "it": "Virgin Mojito",
              "ar": "فيرجن موهيتو"
            },
            "description": {
              "fr": "Virgin Mojito",
              "en": "Virgin Mojito",
              "it": "Virgin Mojito",
              "ar": "فيرجن موهيتو"
            },
            "price": "15.00"
          }
        ]
      }
    ]
  }
};